/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileGamingLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileGamingLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M40.334 31.142c-.951.952-.951 1.877 0 2.828.952.952 1.877.952 2.829 0 .952-.951.952-1.876 0-2.828s-1.877-.952-2.828 0Zm7.072-1.414c-.952.951-.952 1.877 0 2.828.951.952 1.876.952 2.828 0 .952-.951.952-1.876 0-2.828s-1.877-.952-2.828 0Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m37.608 42.354 4.746-4.746 1.861.787c1.059.448 2.007.493 2.977.207 1.035-.305 2.288-1.049 3.75-2.51 2.066-2.067 2.689-3.695 2.689-4.95 0-1.255-.623-2.883-2.69-4.95s-3.695-2.69-4.95-2.69c-1.254 0-2.882.623-4.95 2.69l-14.849 14.85c-2.067 2.067-2.69 3.694-2.69 4.95 0 1.254.623 2.882 2.69 4.949 2.068 2.067 3.695 2.69 4.95 2.69 1.255 0 2.883-.623 4.95-2.69 1.461-1.461 2.205-2.714 2.51-3.75.286-.969.24-1.917-.207-2.976l-.787-1.861Zm5.439-1.196c3.335 1.41 6.642.429 10.015-2.945 4.759-4.758 4.759-9.384 0-14.142-4.758-4.758-9.384-4.758-14.142 0L24.071 38.92c-4.758 4.757-4.758 9.383 0 14.141 4.758 4.758 9.384 4.758 14.142 0 3.374-3.373 4.355-6.68 2.945-10.016l1.889-1.888Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m29.02 45.991-1.767-1.767 2.121-2.122 1.768 1.768 1.768-1.768 2.121 2.122-1.768 1.767 1.768 1.768-2.121 2.121-1.768-1.768-1.768 1.768-2.121-2.121 1.768-1.768Zm1.768-22.981a2.5 2.5 0 0 0 0 3.536l1.061 1.06a5.5 5.5 0 0 1 0 7.779l-4.242 4.242-2.122-2.121 4.243-4.243a2.5 2.5 0 0 0 0-3.535l-1.06-1.06a5.5 5.5 0 0 1 0-7.779l1.413-1.414 2.122 2.121-1.415 1.414Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m31.703 22.096-1.622-1.621-1.414 1.414a5.478 5.478 0 0 0-1.588 3.389 5.489 5.489 0 0 1 1.588-4.39l1.414-1.413 2.122 2.121-.5.5Zm-1.596 3.182a2.498 2.498 0 0 0 .681 2.268l1.061 1.06a5.477 5.477 0 0 1 1.344 2.192l5.727-5.727c4.758-4.758 9.384-4.758 14.142 0 2.21 2.21 3.394 4.391 3.551 6.57.181-2.512-1.002-5.022-3.55-7.57-4.759-4.758-9.385-4.758-14.143 0l-5.727 5.727a5.477 5.477 0 0 0-1.344-2.191l-1.06-1.061a2.488 2.488 0 0 1-.683-1.268Zm11.321 18.498-.27.27c.345.816.547 1.631.606 2.445a7.172 7.172 0 0 0-.336-2.715ZM20.52 46.491c.157-2.18 1.341-4.36 3.551-6.57l5.657-5.658a2.497 2.497 0 0 0 .682-2.267 2.488 2.488 0 0 1-.682 1.267L24.07 38.92c-2.548 2.548-3.732 5.058-3.55 7.571Zm3.015 0a3.94 3.94 0 0 0-.033.5c0 1.255.623 2.883 2.69 4.95 2.068 2.067 3.695 2.69 4.95 2.69 1.255 0 2.883-.623 4.95-2.69 1.461-1.461 2.205-2.714 2.51-3.75.167-.565.22-1.123.148-1.7-.03.233-.079.467-.148.7-.305 1.036-1.049 2.289-2.51 3.75-2.067 2.067-3.695 2.69-4.95 2.69-1.255 0-2.882-.623-4.95-2.69-1.802-1.803-2.507-3.271-2.657-4.45Zm14.37-3.434 4.449-4.45 1.861.788c1.059.448 2.007.493 2.977.207 1.035-.305 2.288-1.049 3.75-2.51 2.066-2.067 2.689-3.695 2.689-4.95 0-.16-.01-.327-.032-.5-.15 1.178-.855 2.647-2.658 4.45-1.461 1.461-2.714 2.205-3.75 2.51-.969.286-1.917.24-2.976-.207l-1.861-.787-4.746 4.746.297.703Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M46.782 31.642c.109-.303.317-.607.624-.914.951-.952 1.876-.952 2.828 0 .307.307.515.61.624.914.229-.637.02-1.27-.624-1.914-.952-.952-1.877-.952-2.828 0-.645.645-.853 1.277-.624 1.914Zm-7.072 1.414c-.228-.637-.02-1.27.624-1.914.952-.952 1.877-.952 2.829 0 .645.645.853 1.277.624 1.914-.11-.303-.317-.607-.624-.914-.952-.952-1.877-.952-2.828 0-.307.307-.515.611-.624.914ZM27.753 44.723l-.5-.5 2.121-2.12 1.768 1.767 1.768-1.768 2.121 2.121-.5.5-1.621-1.62-1.768 1.767-1.768-1.768-1.621 1.621Zm.767 1.768-1.267 1.268.5.5 1.268-1.268-.5-.5Zm6.011 1.768.5-.5-1.268-1.268-.5.5 1.268 1.268Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileGamingLarge
};
